import React from 'react';
import { useSelector } from 'react-redux';
import { selectDrone } from '@src/features/fleet/pages/drones-page/redux';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { ArcButton, ArcIconButton, ArcPagination, ArcSkeleton, ArcStack, ArcTable, ArcTableBody, ArcTableCell, ArcTableHead, ArcTableRow } from '@src/core/ui';
import { arcDateWithTime, arcDownloadFile, arcSecToMin, arcSpatium } from '@src/core/extensions';
import { PAGINATION_DEFAULT_SIZE, ZERO } from '@src/core/config';
import { DroneEntity } from '@src/core/features';
import { useFlightSummaryAllMutation, useFlightSummaryByIdMutation, useGetDroneOrderHistoryQuery } from '@src/features/fleet/redux/api';

const OrderHistoryPanel: React.FC = () => {
  const [page, setPage] = React.useState(0);
  const { id } = useSelector(selectDrone) ?? {} as DroneEntity;
  const { data = { data: [], totalCount: ZERO }, isLoading, isFetching } = useGetDroneOrderHistoryQuery({
    id,
    page,
    size: PAGINATION_DEFAULT_SIZE,
  });

  const [ flightSummaryAll ] = useFlightSummaryAllMutation();
  const [ flightSummaryById ] = useFlightSummaryByIdMutation();

  
  

  if (isLoading || isFetching) {
    return (
      <ArcStack spacing={1}>
        {Array(7).fill(1).map((_, idx) => {
          return <ArcSkeleton key={idx} height={40} />;
        })}
      </ArcStack>
    );
  }

  const onDownloadById = (id: number) => {
    flightSummaryById(id).unwrap().then((filePath) => {
      arcDownloadFile(filePath, `drone_order_${id}_history.csv`);
    }).catch(() => {});
  };

  const onDownloadAll = () => {
    flightSummaryAll().unwrap().then((filePath) => {
      arcDownloadFile(filePath, `all_history.csv`);
    }).catch(() => {});
  };

  
  return (
    <ArcStack sx={{ overflowY: 'scroll' }} maxHeight='60vh'>
      <ArcStack direction='row' justifyContent='flex-end' marginLeft={'auto'} marginBottom={2} width='15.5%'>
        <ArcButton.brand onClick={onDownloadAll} fullWidth> Download All </ArcButton.brand>
      </ArcStack>
      <ArcTable>
        <ArcTableHead>
          <ArcTableRow>
            <ArcTableCell> Date </ArcTableCell>
            <ArcTableCell> Flight Time </ArcTableCell>
            <ArcTableCell> Distance </ArcTableCell>
            <ArcTableCell> Order # </ArcTableCell>
            <ArcTableCell> Flight Data</ArcTableCell>
          </ArcTableRow>
        </ArcTableHead>

        <ArcTableBody>
          {data.data.map((order) => {
            return (
              <ArcTableRow key={order.id}>
                <ArcTableCell> {arcDateWithTime(order.createDate)} </ArcTableCell>
                <ArcTableCell> {arcSecToMin(order.totalFlightTime)} </ArcTableCell>
                <ArcTableCell> {arcSpatium(order.totalDistance)} </ArcTableCell>
                <ArcTableCell> {order.id} </ArcTableCell>
                <ArcTableCell> 
                  <ArcIconButton onClick={() => onDownloadById(order.id)}> 
                    <DownloadForOfflineIcon />  
                  </ArcIconButton> 
                </ArcTableCell>
              </ArcTableRow>
            );
          })}
        </ArcTableBody>
      </ArcTable>
      {PAGINATION_DEFAULT_SIZE < data.totalCount &&
        (
          <ArcStack mt={2} alignItems='center'>
            <ArcPagination 
              page={page + 1} 
              count={Math.ceil(data.totalCount / PAGINATION_DEFAULT_SIZE)} 
              onChange={(_, page) => setPage(page - 1)} />
          </ArcStack>
        )
      }
    </ArcStack>
  );
};

export default OrderHistoryPanel;